import Capability from '../../model/access/capability';
import Collection from '../../collection';





export default Collection.extend( {
    endpoint: 'tasks/capabilities?apiVersion=2.0',
    responseAt: 'items',
    model: Capability,

    parseResponse(attrList/*, response*/) {
        return attrList
            .sort( (a, b) => a.label < b.label
                ? -1
                : b.label < a.label 
                    ? 1
                    : a.id - b.id );
    }
} );


// WEBPACK FOOTER //
// ./src/js/collection/access/capabilities.js